import { backendApiUrl } from '../../config/api-url';

export class Paths {
  static MAIN = '/';
  static LOGIN = '/login';
  static DASHBOARD = '/dashboard';
  static MANAGE_ACCOUNTS = `${this.DASHBOARD}/users`;
  static MANAGE_BOT_SEATING = `${this.DASHBOARD}/account-seating`;
  static MANAGE_BOT_PARAMS = `${this.DASHBOARD}/account-params`;
  static ACTUATOR = backendApiUrl;
  static HISTORY = '/history';
}
